import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import SimpleBar from 'simplebar-react'
import 'simplebar-react/dist/simplebar.min.css'
import { CBadge, CNavLink, CNavItem, CSidebarNav, CNavGroup } from '@coreui/react'

export const BackAppSidebarNav = ({ items }) => {
  const location = useLocation()

  const navLinkContent = (name, icon, badge, indent = false) => (
      <>
        {icon ? (
            icon
        ) : (
            indent && (
                <span className="nav-icon">
            <span className="nav-icon-bullet"></span>
          </span>
            )
        )}
        {name && <span className="nav-label">{name}</span>}
        {badge && (
            <CBadge color={badge.color} className="ms-auto" size="sm">
              {badge.text}
            </CBadge>
        )}
      </>
  )

  const renderNavItem = (item, index, indent = false) => {
    const { component, name, badge, icon, to, href, ...rest } = item
    const Component = component || CNavItem

    return (
        <Component key={index}>
          {to || href ? (
              <CNavLink
                  {...(to && { as: NavLink, to, end: true })}
                  {...(href && { href, target: '_blank', rel: 'noopener noreferrer' })}
                  {...rest}
              >
                {navLinkContent(name, icon, badge, indent)}
              </CNavLink>
          ) : (
              navLinkContent(name, icon, badge, indent)
          )}
        </Component>
    )
  }

  const renderNavGroup = (item, index) => {
    const { component, name, icon, items, ...rest } = item
    const Component = component || CNavGroup

    return (
        <Component key={index} toggler={navLinkContent(name, icon)} {...rest}>
          {items?.map((child, idx) =>
              child.items ? renderNavGroup(child, idx) : renderNavItem(child, idx, true),
          )}
        </Component>
    )
  }

  return (
      <CSidebarNav as={SimpleBar}>
        {items &&
            items.map((item, index) =>
                item.items ? renderNavGroup(item, index) : renderNavItem(item, index),
            )}
      </CSidebarNav>
  )
}

BackAppSidebarNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
}
